<template><div class="MySliderEx" :style="{ '--slider-count': props.excursion.length }">
    <div class="MySliderEx__head">
        <div class="MySliderEx__head__title">{{HaveNExcursion(props.excursion.length)}}</div>
        <nav v-if="hasPrev || hasNext">
        <button @click="prev" class="MySliderEx__head__but" :class="{'active': hasPrev, 'inactive': !hasPrev}">
          <vDown class="MySliderEx__head__but__svg left"  />
        </button>
        <button @click="next" class="MySliderEx__head__but" :class="{'active': hasNext, 'inactive': !hasNext}">
          <vDown class="MySliderEx__head__but__svg right"  />
        </button>
        </nav>        
    </div>
    <!--responsive-->
    <vue-horizontal class="horizontal MySliderEx__slider"  :button="false" ref="horizontal" @scroll-debounce="onScroll">
        <div v-for="slide in props.excursion" :key="slide.id" class="MySliderEx__ex">
            <div>{{slide.name}}</div>
            <ExcursionInner :excursion="slide" />
            <MyModalExcursion v-if="slide.description" :excursion="slide" />
        </div>
    </vue-horizontal>
</div></template>

<style lang="scss" src="./MySliderExcursion.scss"></style>

<script setup>
import {ref, unref, onMounted, onBeforeUnmount, computed} from 'vue'
import VueHorizontal from 'vue-horizontal';
import vDown from '@/assets/vicons/chevron-down.vue'
import {HaveNExcursion} from '@/util.js'

import MyModalExcursion from './MyModalExcursion.vue'
import ExcursionInner from './ExcursionInner.vue'


const props = defineProps({
  excursion: { // id name type description 
    type: Array,
    default: ()=>[],   
    required: true,
  },
})


const hasPrev = ref(false)
const hasNext = ref(false)
const horizontal = ref(null)

const prev = () => horizontal.value && horizontal.value.prev()
const next = () => horizontal.value && horizontal.value.next()

const onScroll = (ob) => {
    hasPrev.value = ob.hasPrev
    hasNext.value = ob.hasNext
}

const set_nav = () => {// переставить переменные после resize окна
    let slider = unref(horizontal)
    if (slider) {
        let ob = slider.calculate()
        hasPrev.value = ob.hasPrev
        hasNext.value = ob.hasNext
    }
}


onMounted(()=> {// onScroll генерится при старте
    window.addEventListener('resize', set_nav)
})
onBeforeUnmount(()=>{
    window.removeEventListener('resize', set_nav)
})

</script>
